var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.587 12.087a.584.584 0 10.826.826l-.826-.826zM11 8.5l.413.413a.584.584 0 000-.826L11 8.5zM7.413 4.087a.584.584 0 10-.826.826l.826-.826zm0 8.826l4-4-.826-.826-4 4 .826.826zm4-4.826l-4-4-.826.826 4 4 .826-.826z",
    fill: "#ADB5BD"
  })));
}

export default SvgChevronRight16;